import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { generateRandomId } from "../utils/helpers";

const getSingleChat = (threadId) => {
  const loginData = secureLocalStorage.getItem("loginCredentials");

  return new Promise((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_NODE_BASE_URL}/chats/${loginData.user.id}/getSingleChat/${threadId}`
      )
      
      .then((res) => {
        console.log("Fetched Chat Data:", res.data);
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};

const getAllChats = () => {
  const loginData = secureLocalStorage.getItem("loginCredentials");
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_NODE_BASE_URL}/chats/getAllChats/${loginData.user.id}`
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};

const sendQuery = (query, threadId, files) => {
  const randomId = generateRandomId()
  const loginData = secureLocalStorage.getItem("loginCredentials");
  const formData = new FormData();
  formData.append("query", query);
  formData.append("user_id", loginData.user.id);
  formData.append("thread_id", threadId);
  formData.append("message_id", randomId);

  if (files) {
    formData.append("files", files);
  }
  return new Promise((resolve, reject) => { 
    axios
      .post( `${process.env.REACT_APP_PYTHON_URL}/api/v1/legal/query`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {

        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};

const getThread = (userId) => { 
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_NODE_BASE_URL}/chats/user-thread/${userId}`
      )
      .then((res) => {
        console.log("Fetched Thread Data:", res.data);
        resolve(res.data);
      })
      .catch((err) =>  {
        console.error("Error fetching thread data:", err);  
        reject(err);
      });
  });
}


export{
  getSingleChat,
  getAllChats,
  sendQuery,
  getThread

}